<template>
    <!-- 法律申明 -->
    <div class="box index-less">
        <details-head img="./img/bj3.png" title="法律申明" remarks="Declaration Law" />
        <TopBreadcrumb :data="[{ label: '规划协会' }, { label: '法律申明' }]" />
        <div class="con">
            <!-- <TopTab/> -->
            <div class="box">
                <div class="left">
                    <Left title="法律申明" remarks="Copyright Notice" />
                </div>
                <Right title="法律申明" :context="context" />
            </div>
        </div>
    </div>
</template>
  
<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import Left from "./comp/Left.vue";
import Right from "./comp/Right.vue";
import TopTab from "./comp/TopTab.vue";
import './comp/index.less'
export default {
    name: "Home",
    components: { DetailsHead, TopBreadcrumb, Left, Right, TopTab },
    data() {
        return {
            context: `<b>网站使用规定</b>
    本网站属于企业网站，任何组织和个人不得非法复制、抄袭，或为任何未经允许的商业目的使用本网站及其内容。如果本网站所有者确定用户行为违法或有损网站利益，则将保留采取相关法律行为的权利。
本网站努力确保本网站自身发布的信息、资料等内容的真实性和准确性， 本网站可能通过网页上的链接向用户提供来自其它网站的内容及服务。本网站对这些网站及其内容不进行控制，也不负任何责任。请用户在使用该类网站所提供的服务时注意浏览这些网站的相关规定，并自行判断可能带来的结果和风险，以决定是否使用这些网站提供的内容或服务。

<b>免责声明</b>
    本网站所发布的信息，不声明或保证其内容之正确性或完整性；本网站转载的相关文章、资料中表述或暗示的观点不代表北京传诚信的观点。本网站对本网站上所有由第三方提供的信息、内容和服务，不提供明示或暗示的担保；本网站对使用上述信息、内容和服务所造成的任何损失不承担责任，包括直接损失和间接损失。

<b>适用法律</b>
    适用中华人民共和国法律。我们保留随时更改我们的网站和上述免责及条款的权利`
        };
    },
    methods: {},
};
</script>